export default "__VITE_ASSET__CdLSuIHX__"